module.exports = __webpack_public_path__ + "img/71_23.91f7e1ba.png";